import { NgxSpinner, NgxSpinnerService } from "ngx-spinner";

import { CustomSpinnerService } from "./services/custom-spinner-service";
import { SpinnerType } from "./enums";

export class BaseComponent {

constructor(private spinner:NgxSpinnerService ){
 this.spinner=spinner


}
 customSpinnerservice:CustomSpinnerService = new CustomSpinnerService(this.spinner);




spinnerShow(type:SpinnerType): void{

   this.customSpinnerservice.showSpinner(type);
}
spinnerHide(type:SpinnerType){
   this.customSpinnerservice.hideSpinner(type);
}





}

